import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpParams } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import Utils from 'src/app/helpers/Util';
import { NzNotificationService } from 'ng-zorro-antd/notification';

export const dataHistory: Array<{ CodeName: string, Name: string }> = [
    { CodeName: "THIS_MONTH", Name: "This Month" },
    { CodeName: "LAST_MONTH", Name: "Last Month" },
    { CodeName: "THIS_QUARTER", Name: "This Quarter" },
    { CodeName: "LAST_QUARTER", Name: "Last Quarter" },
    { CodeName: "THIS_YEAR", Name: "This Year" },
    { CodeName: "LAST_YEAR", Name: "Last Year" }
]; 


const DEFAULTCURRENCY_OBJECT: Currency = {
    Id: null,
    Code: 'USD'
}

export interface DEFAULTSETTINGS {
    client: string,
    currency: Currency
}

export interface Currency{
    Id: number,
    Code: string
}

@Injectable()
export class GlobalService {
    constructor(
        private notificationService: NzNotificationService,
    ) {

    }
    
    get CLIENT_CURRENCY_LIST(): any {
        return JSON.parse(localStorage.getItem('currency'));
      }
      
    set CLIENT_CURRENCY_LIST(data: any) {
        localStorage.setItem('currency', JSON.stringify(data));
    }

    GET_CURRENCY_OBJECT_VIA_ID(id: number){
        if(id)
            return this.CLIENT_CURRENCY_LIST?.currency.filter(x => x.Id == id).shift();
        return null;
    }

    serialize(obj: any): any {
        if (obj == null)
            return {};

        let params = new HttpParams();
        for (var key in obj) {
            if (obj.hasOwnProperty(key)) {
                var element = obj[key];
                params = params.set(key, element);
            }
        }
        return params;
    }

    isJSONStringValid(jsonString: string): boolean{
        try {
            JSON.parse(jsonString);
        } catch (e) {
            return false;
        }
        return true;
    }

    isEmptyObject(obj){
        return JSON.stringify(obj) === '{}'
    }

    isEmpty(value: any) {
        return (value === undefined || value == null || value.length === 0);
    }

    checkIfCurrencyIsAvailable(Code: string, d_CLIENTS_CURRENCY: any): Currency {
        var currency = d_CLIENTS_CURRENCY.currency?.filter(x => x.Code == Code)?.shift();
        if(currency) return currency;
        return DEFAULTCURRENCY_OBJECT;
    }

    defaultApplicationSettings(settings: any, d_CLIENTS_CURRENCY: any = null): any {
        var _settings = Utils.DeepCopy(settings);
        
        if ('WebResCurrencySelected' in _settings === false) {
            _settings["WebResCurrencySelected"] = DEFAULTCURRENCY_OBJECT
        } else {
            // If WebCurrency is an object but doesn't have WebResCurrencySelected properties
            if(typeof _settings['WebResCurrencySelected'] === 'object' && 
                ('Id' in _settings['WebResCurrencySelected'] === true && 'Code' in _settings['WebResCurrencySelected'] === true) &&
                    (_settings['WebResCurrencySelected']?.Id == null || _settings['WebResCurrencySelected']?.Code == null)
                ){
                _settings['WebResCurrencySelected'] = this.checkIfCurrencyIsAvailable('USD',d_CLIENTS_CURRENCY);
            }

            if(typeof _settings['WebResCurrencySelected'] === 'string'){
                // If currency is string and has valid currency value
                if(!this.isEmpty(_settings['WebResCurrencySelected'])){
                    _settings["WebResCurrencySelected"] = this.checkIfCurrencyIsAvailable(_settings['WebResCurrencySelected'], d_CLIENTS_CURRENCY);
                    
                } else{
                    _settings["WebResCurrencySelected"] = this.checkIfCurrencyIsAvailable('USD', d_CLIENTS_CURRENCY);
                }
            }
        }

        if('InvoiceGridHideSelectedColumn' in _settings === false){
            _settings["InvoiceGridHideSelectedColumn"]  = {
                InvoiceNo:                      false,
                InvoiceDate:                    false,
                DueDate:                        false,
                ClientCode:                     false,
                ClientRegion:                   false,
                ClientCountry:                  false,
                ClientCity:                     true,
                ClientDivision:                 true,
                ClientLocation:                 true,
                CarrierCode:                    true,
                CarrierName:                    true,
                CarrierCity:                    false,
                CarrierCountry:                 false,
                Currency:                       false,
                BilledAmount:                   false,
                ShipmentMode:                   false,
                ServiceLevel:                   false,
                OriginCountryCode:              false,
                DestinationCountryCode:         false,
                ResolutionReasonCode:           false
            };
        }

        if('WebResClientSelected' in _settings === false || ('WebResClientSelected' in _settings === true && this.isEmpty(_settings['WebResClientSelected']))){
            if(d_CLIENTS_CURRENCY?.client?.Clients?.length > 0)
                _settings['WebResClientSelected'] = d_CLIENTS_CURRENCY?.client?.Clients[0];
            else{
                _settings['WebResClientSelected'] = ''
            }
        }

        if('WebResPeriodSelected' in _settings === false){
            _settings['WebResPeriodSelected'] = '';
        }

        if('GeneralSettings' in _settings === false){
            _settings['GeneralSettings'] = 'General Settings';
        }

        if('RuleDisplayColumnSummary' in _settings === false){
            _settings["RuleDisplayColumnSummary"]  = [];
        }

        if('AutopassConditionColumns' in _settings === false){
            _settings["AutopassConditionColumns"]  = [];
        }
        return _settings;
    }


    createNotification(type: string, title: string, message: string, durationBySeconds: number = 5): void {   
        this.notificationService.create(
          type,
          title,
          message,
          {
            nzDuration: durationBySeconds * 1000
          }
        );
      }
}